import React from 'react';
import './MeetSuzi.css';

const MeetSuzi: React.FC = () => {
  return (
    <div className="meet-suzi-page">
      <section className="suzi-hero">
        <h1>Meet Suzanne</h1>
        <p>Founder of The Pet Nanny of Weston Since 2017</p>
      </section>

      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-image">
              <img src="/photos/suzi-bailey.jpg" alt="Suzi with a dog" />
            </div>
            <div className="about-text">
              <h2>Hello! I'm Suzanne 👋</h2>
              <p>
                Welcome to The Pet Nanny of Weston! I'm Suzanne Faze, and I founded this 
                business in 2017. Caring for animals has been one of the greatest joys of 
                my life. From the tiniest kitten to the most loyal senior pup, every pet 
                I care for holds a special place in my heart.
              </p>
              <p>
                For me, pet sitting isn't just a job — it's a calling. I've built my business 
                on the belief that our pets are family, and they deserve to feel loved, safe, 
                and understood when their people are away. My clients know me as someone who 
                goes above and beyond — offering gentle care, a nurturing touch, and genuine 
                companionship to every animal in my care.
              </p>
              <p>
                With years of experience and a lifetime of love for animals, I bring not only 
                dependability and professionalism, but also warmth, empathy, and a sense of home. 
                Whether it's daily visits, overnight stays, or cozy boarding, my goal is always 
                the same: to make sure your pets feel secure, happy, and loved — just like they 
                would with you.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="experience-section">
        <div className="container">
          <h2>Experience & Passion</h2>
          <div className="experience-grid">
            <div className="experience-card">
              <span className="exp-icon">🐕</span>
              <h3>All Breeds Welcome</h3>
              <p>From tiny Chihuahuas to gentle Great Danes, I have experience with dogs of all sizes and temperaments.</p>
            </div>
            <div className="experience-card">
              <span className="exp-icon">🐈</span>
              <h3>Feline Friends</h3>
              <p>I understand cats need a calm, safe environment. Your kitty will have quiet spaces and gentle care.</p>
            </div>
            <div className="experience-card">
              <span className="exp-icon">💊</span>
              <h3>Special Needs Care</h3>
              <p>Experienced in administering medications, following dietary restrictions, and caring for senior pets.</p>
            </div>
            <div className="experience-card">
              <span className="exp-icon">🏠</span>
              <h3>Home Environment</h3>
              <p>My home offers a secure, fenced backyard and comfortable indoor spaces for your pet's comfort.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="gallery-section">
        <div className="container">
          <h2>Life at The Pet Nanny</h2>
          <p className="section-subtitle">Some of my wonderful guests enjoying their stay!</p>
          <div className="photo-gallery">
            <div className="gallery-item large">
              <img src="/photos/suzi-2-dogs-couch.jpg" alt="Suzi with dogs on couch" />
            </div>
            <div className="gallery-item">
              <img src="/photos/dog-harley-2.jpg" alt="Harley the dog" />
            </div>
            <div className="gallery-item">
              <img src="/photos/dog-zorro.jpg" alt="Zorro the dog" />
            </div>
            <div className="gallery-item">
              <img src="/photos/dog-poodle-leash.jpg" alt="Poodle on walk" />
            </div>
            <div className="gallery-item">
              <img src="/photos/dog-ray.jpg" alt="Ray the dog" />
            </div>
            <div className="gallery-item large">
              <img src="/photos/3-dogs-backyard-fence.jpg" alt="Dogs playing in backyard" />
            </div>
            <div className="gallery-item">
              <img src="/photos/suzi-cat-ringo.jpg" alt="Suzi with cat Ringo" />
            </div>
            <div className="gallery-item">
              <img src="/photos/dog-mandi.jpg" alt="Mandi the dog" />
            </div>
          </div>
        </div>
      </section>

      <section className="promise-section">
        <div className="container">
          <h2>My Promise To You</h2>
          <div className="promise-content">
            <div className="promise-list">
              <div className="promise-item">
                <span className="check">✓</span>
                <div>
                  <h4>Loving Care</h4>
                  <p>Your pet will receive the same love and attention I give my own animals.</p>
                </div>
              </div>
              <div className="promise-item">
                <span className="check">✓</span>
                <div>
                  <h4>Regular Updates</h4>
                  <p>I'll send you photos and updates so you know your pet is happy and safe.</p>
                </div>
              </div>
              <div className="promise-item">
                <span className="check">✓</span>
                <div>
                  <h4>Following Your Routine</h4>
                  <p>I maintain your pet's feeding schedule, medications, and routines.</p>
                </div>
              </div>
              <div className="promise-item">
                <span className="check">✓</span>
                <div>
                  <h4>Safe Environment</h4>
                  <p>A secure, clean, and comfortable home for your furry family member.</p>
                </div>
              </div>
              <div className="promise-item">
                <span className="check">✓</span>
                <div>
                  <h4>Open Communication</h4>
                  <p>I'm always available to answer questions and address any concerns.</p>
                </div>
              </div>
            </div>
            <div className="promise-image">
              <img src="/photos/dog-zorro-2.jpg" alt="Happy dog" />
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <h2>Let's Connect!</h2>
          <p>Have questions? Want to schedule a meet and greet? I'd love to hear from you!</p>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <div>
                <h4>Location</h4>
                <p>Weston, Florida</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📧</span>
              <div>
                <h4>Email</h4>
                <p>thepetnannyofweston@gmail.com</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <div>
                <h4>Phone</h4>
                <p>Call or Text for Inquiries</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MeetSuzi;
